module.exports = __webpack_public_path__ + "img/idle.a26c6aa5.png";